import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UsersService } from 'src/app/services/users.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { UsersEditPasswordComponent } from '../users-edit-password/users-edit-password.component';

@Component({
  selector: 'app-users-edit',
  templateUrl: './users-edit.component.html',
  styleUrls: ['./users-edit.component.scss']
})
export class UsersEditComponent {

  rolesList!: {
    id: number,
    rol: string
  }[];

  formUser!: FormGroup;
  id_user!: number;
  isUserLogged!: boolean;
  permissionList : any = [];
  selected : any = [];
  modulesList : any = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
    private fb: FormBuilder,
    private userS: UsersService,
    private dialogRef: MatDialogRef<UsersEditComponent>,
    private matDialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.rolesList = environment.roles;
    this.id_user = this.data.userSel.id;
    this.isUserLogged = this.id_user == this.userS.getUser().id;
    this.createFormUser();
    this.setUserForm();
  }

  createFormUser() {
    this.formUser = this.fb.group({
      name: ['', [ Validators.required, Validators.minLength(3)]],
      id_rol: ['', [Validators.required]],
      permissions: ['', []],
      modules: ['', []]
    });
  }

  unselect(obj : any): void {
    obj = undefined;
 }

  getPermissions(){
    console.log("ID ROL" + this.formUser.value.id_rol)
    if(this.formUser.value.id_rol > 1) {
      this.userS.getPermissionList(this.formUser.value.id_rol).subscribe(
        (result:any) => {
          if(result.message == "Success") {
            this.permissionList = result.data;
            this.formUser.controls["permissions"].setValue(this.data.userSel.permissions.map((elem: { id: any; }) => elem.id));
          }
        },
        (err:any) => {
          console.log(err);
        }
      )
    }
    else this.permissionList = [];
  }

  getModules(){
    if(this.formUser.value.id_rol > 2) {
      this.userS.getModules().subscribe(
        (result:any) => {
          if(result.message == "Success") {
            this.modulesList = result.data;
            this.formUser.controls["modules"].setValue(this.data.userSel.modules.map((elem: { id: any; }) => elem.id));
          }
        },
        (err:any) => {
          console.log(err);
        }
      );
    }else{
      this.userS.getModules().subscribe(
        (result:any) => {
          if(result.message == "Success") {
            this.modulesList = result.data;
            this.formUser.controls["modules"].setValue(this.data.userSel.modules.map((elem: { id: any; }) => elem.id));
          }
        },
        (err:any) => {
          console.log(err);
        }
      );
    }
  }

  setUserForm() {
    const { active, email, id, rol_name, ch_pass, ...userFormInfo } = this.data.userSel;
    this.formUser.setValue(userFormInfo);
    this.getPermissions();
    this.getModules();
  }

  ruSure() {
    if(this.formUser.invalid) { return; }
    Swal.fire({
      title: '¿Estás seguro que deseas editar el registro?',
      icon: 'warning',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: `Confirmar`,
      cancelButtonText: `Cancelar`
    }).then((result) => {      
      if (result.isConfirmed) {
        this.saveUser();
      }
    });
  }

  saveUser() {
    Swal.fire({
      icon: 'info',
      title: 'Guardando...',
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.formUser.value.comision = {tipo: this.formUser.value.tipo_comision, cantidad: this.formUser.value.cant_comision};
    const company = this.formUser.value.id_company;
    this.formUser.value.id_company = company ? company : 0;
    this.userS.editUser(this.formUser.value, this.id_user).subscribe(
      (result:any) => {
        if(result.message == "Success") {
          Swal.fire({
            icon: 'success',
            title: 'Guardado',
            html: 'Usuario guardado de manera correcta!'
          }).then(() => {            
            this.dialogRef.close({ reload: false });
          });
        }
      },
      (err:any) => {
        console.log(err);
        Swal.fire({
          icon: 'error',
          title: 'Error al guardar',
          text: 'Ocurrió un error al guardar el registro, por favor vuelva a intentarlo.'
        });
      }
    );
  }

  openDialogPassword() {
    this.matDialog.open(UsersEditPasswordComponent, {
      data: { 
        id_user: this.id_user 
      },
      panelClass: 'dialogs-sm',
    });
  }

  toggleSelectAllPermissions() {
    let allPermissions = this.permissionList.map((p : any) => p.id);
    let currentPermissions = this.formUser.get('permissions')?.value || [];

    if (currentPermissions.length != 0) {
      this.formUser.get('permissions')?.setValue([]);
    } else {
      this.formUser.get('permissions')?.setValue(allPermissions); 
    }
  }

  getPermbyModule(id_mod : number){
    return this.permissionList.filter((x:any)=>{ return x.id_modulo == id_mod })
  }

  toggleSelectAllByModule(id_mod: number, checked: boolean) {
    const modulePermissions = this.getPermbyModule(id_mod).map((p : any) => p.id);
    const currentPermissions = this.formUser.get('permissions')?.value || [];

    if (checked) {
      const newPermissions = [...currentPermissions, ...modulePermissions];
      this.formUser.get('permissions')?.setValue([...new Set(newPermissions)]); 
    } else {
      const newPermissions = currentPermissions.filter(
        (id: any) => !modulePermissions.includes(id)
      );
      this.formUser.get('permissions')?.setValue(newPermissions);
    }
  }

  isModuleFullySelected(id_mod: number): boolean {
    const modulePermissions = this.getPermbyModule(id_mod).map((p : any) => p.id);
    const currentPermissions = this.formUser.get('permissions')?.value || [];
    return modulePermissions.every((id : any) => currentPermissions.includes(id));
  }

  isModulePartiallySelected(id_mod: number): boolean {
    const modulePermissions = this.getPermbyModule(id_mod).map((p : any) => p.id);
    const currentPermissions = this.formUser.get('permissions')?.value || [];
    const anySelected = modulePermissions.some((id : any) =>
      currentPermissions.includes(id)
    );
    const allSelected = modulePermissions.every((id : any) =>
      currentPermissions.includes(id)
    );
    return anySelected && !allSelected;
  }

  toggleSelectAllModules() {
    let allModules = this.modulesList.map((p : any) => p.id);
    let currentModules = this.formUser.get('modules')?.value || [];

    if (currentModules.length != 0) {
      this.formUser.get('modules')?.setValue([]);
    } else {
      this.formUser.get('modules')?.setValue(allModules); 
    }
  }

}
